import React from 'react'
import { styled } from '@linaria/react'

interface IProp  {
    background :string,
    sideBarBackground: string
    iconImg?:string
    height?:string
    mobileHeight?: string;
}
function AlertNotification({background,sideBarBackground,height,mobileHeight,iconImg, ...prop}: React.PropsWithChildren<IProp>) {
  return (
    <Div height={height} mobileHeight={mobileHeight} background={background} sideBar={sideBarBackground}>
      {iconImg &&  <img src={iconImg} width={24} height={24} alt="icon-img"/>}
       {prop.children}  
        
    </Div>
  )
}

export default AlertNotification

const Div = styled.div<{background:string, sideBar: string, height?: string, mobileHeight?: string}>`
    display: flex;
    align-items: center;
    background-color: ${prop=>prop.background};
    gap:8px;
    height: ${prop => prop.height ? prop.height : '56px'};
    border-radius: 16px;
    overflow: hidden;
    &::before{
        content: '';
        height: 100%;
        width: 8px;
        padding: 0;
        background-color: ${prop=>prop.sideBar};
    }
    img {
        margin-top: -3px;
    }

    @media screen and (max-width: 768px) {
      height: ${prop => prop.mobileHeight ? prop.mobileHeight : '56px'};
   }
`